import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloFacetteFamTrad extends AloBase {    
    key:string     
    famId:number    
    famIdx:number    
    famLibelle:string
}

export const getDefaultAloFacetteFamTrad = ():AloFacetteFamTrad => {
    return {
        ...getDefaultAloBase(),
        key:'',
        famId:0,
        famIdx:0,
        famLibelle:''
    }
}

export const cleanAloFacetteFamTrad = (facetteFamTrad:AloFacetteFamTrad) => {
    if(!facetteFamTrad) return    
    if(!facetteFamTrad.id) delete facetteFamTrad.id    
    if(!facetteFamTrad.famId) delete facetteFamTrad.famId    
}

